// Stonehush quest — bell interact (world XZ). Shared by TownNPCs + bell HUD.
export const STONEHUSH_BELL_WORLD = { x: -828, z: -5060 };
export const STONEHUSH_BELL_INTERACT_R = 7.5;
